import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import SideBar from "../common/sideBar";
import HeaderAdminpanel from "../common/HeaderAdminpanel";  
import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";
import Pagination from "../common/Pagination";
import NoData from "../common/NoData";
import useModel from "../common/useModel";
import Model from "../common/model";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
const RateCard = (props) => {
  //Set initial state
  const [rodp, handleRodp] = useState([]);
  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const { isShowing, toggle } = useModel();
  const [rates, handleRates] = useState([]);
  const [searchName, handleSearchName] = useState(undefined);
  const adminData = JSON.parse(localStorage.getItem("adminInfo"));
  useEffect(() => {
    getCityStateRate(0);
  }, []);

  //Update rate for city state
  const updateRate = async (params) => {
    try {
      const data = await Axios.put(endPoints.updateRates, params);
      const result = data.data.data.data;
      if (result && !toast.isActive("1")) {
        toast.success("Changes successfully updated", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          toastId: "1",
        });
        toggle();
        getCityStateRate(0);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Fetching City state Rate
  const getCityStateRate = async (skip, station) => {
    handleSkip(skip);
    try {
      const data = await Axios.get(endPoints.getCityStateRate, {
        params: {
          skip,
          station,
        },
      });
      const result = data.data.data.data;
      if (result) {
        handleRodp(result);
        handleCount(data.data.data.count);
        handleSearchName(station);
      }
    } catch (error) {
      console.log(error);
      handleRodp([]);
    }
  };

  //Search city state
  const getSearch = (e) => {
    getCityStateRate(0, e.target.value);
  };

  const openPopup = (rates) => {
    handleRates(rates);
    toggle();
  };

  //Return the table for city state
  return (
    <div className="dashboardContainer">
      <Model isShowing={isShowing} hide={toggle} rates={rates} updateRate={updateRate} />
      <HeaderAdminpanel/>

      {/* <div className="navbar-header dashboard-header clearfix">
        <div className="logo-dashboard">
          <a id="logo">
            <img className="logo-trans" src="/assets/images/new_logo.png" />
          </a>
          <span>Welcome: {adminData.email} </span>
          <span>Last Login @ {moment(adminData.lastLogin).format("DD/MM/YYYY hh:mm A")}</span>
        </div>
        <div
          className="user-profile pull-right"
          tabIndex={0}
          onClick={() => {
            localStorage.removeItem("adminInfo");
            window.location.href = "/admin/login";
          }}
        >
          <a>
            <span>
              LOGOUT
              <span className="log_img">
                <img src="/assets/images/ic_logout.png" />
              </span>
            </span>
          </a>
        </div>
      </div> */}
      <div className="dashboardContainer-inner">
        <section id="sidebar">
          <SideBar />
        </section>
        <section id="dashboard-rightContainer" className="dashboard-manageSales">
          <div className="container-head">
            <div className="dashboard-breadcrumb">
              Rate Management |<span className="breadcrumb-active fct-breadcrumb">Rate Card</span>
            </div>
            <div className="search_camp">
              <input type="text" placeholder="search" onChange={getSearch} />
              <span>
                <img src="/assets/images/search.png" />
              </span>
            </div>
          </div>
          <div
            className={
              rodp.length === 0 && searchName
                ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                : "dashboard-content userListing-dashboard bg-white table-responsive"
            }
          >
            <table className="table table-striped master-table">
              <thead>
                <tr>
                  <th>Region</th>
                  <th>Station</th>
                  <th>State</th>
                  <th>RODP (INR)</th>
                  <th>Custom Premium (%)</th>
                  <th>Min Value (INR)</th>
                  <th>Station Start Time</th>
                  <th>Station End time</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {rodp.map((r) => (
                  <tr>
                    <td>{r.region}</td>
                    <td>{r.station}</td>
                    <td>{r.state}</td>
                    <td>{r.rodpRate.toFixed(2)}</td>
                    <td>{r.customRodpRate? r.customRodpRate : 10}</td>
                    <td>{r.minValue? r.minValue: 0}</td>
                    <td>{r.startTime && moment(r.startTime).format('hh A')}</td>
                    <td>{r.endTime && moment(r.endTime).format('hh A')}</td>
                    <td className="">
                      <a>
                        <span className="tooltip-reject fct-edit" onClick={openPopup.bind(this, r)}>
                          <img src="/assets/images/edit.png" />
                          <span>Edit</span>
                        </span>
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="paginationTable">
              {(skip > 0 || count >= 10) && rodp.length > 7 && (
                <Pagination getAllData={getCityStateRate} totalRecords={count} />
              )}
            </div>
          </div>
          {rodp.length === 0 && searchName ? <NoData /> : null}
        </section>
      </div>
      <ToastContainer />
    </div>
  );
};

export default connect(null, {})(RateCard);



// WEBPACK FOOTER //
// ./web/components/admin/managerateCard/index.js